import React from "react";

// Color input with a visual swatch picker + an editable hex text field (synced).
// onChange is called with an event-like object { target: { value } } so it stays
// drop-in compatible with native <input type="color"> handlers.
export const ColorField = ({ value, onChange, className = "", type, ...rest }) => {
  const v = value || "";
  const valid = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(v);
  const fire = (val) => onChange && onChange({ target: { value: val } });

  return (
    <span className={`flex items-stretch overflow-hidden rounded-lg border border-[#0B1D3A]/15 bg-white min-h-9 ${className}`}>
      <input
        type="color"
        value={valid ? v : "#000000"}
        onChange={(e) => fire(e.target.value)}
        className="w-10 shrink-0 cursor-pointer self-stretch border-0 bg-transparent p-0"
        aria-label="Escolher cor"
      />
      <input
        type="text"
        value={v}
        onChange={(e) => {
          let s = e.target.value.trim();
          if (s && !s.startsWith("#")) s = "#" + s;
          fire(s);
        }}
        placeholder="#RRGGBB"
        spellCheck={false}
        className="min-w-0 flex-1 px-2 py-1 font-mono text-xs uppercase outline-none"
        {...rest}
      />
    </span>
  );
};

export default ColorField;
